// Utility function to generate filestore URLs
export function getFilestoreUrl(path: string): string {
  return `/filestore/${path}`;
}